<template>
    <Teleport to="body">
        <div class="modal fade" :class="additionalClass" :data-bs-backdrop="backdrop || 'true'" :id="id" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" :class="{ 'modal-lg': large }">
                <div class="modal-content mb:66!@<sm">
                    <div class="modal-header">
                        <slot name="modallabel"></slot>
                        <button class="btn-close" data-bs-dismiss="modal" type="button" v-if="close"></button>
                    </div>
                    <div class="modal-body p-0">
                        <div class="t:center p:0|24|32 p:0|48|48@sm">
                            <div class="f:32@xl f:24@sm f:20@<sm">
                                <slot></slot>
                            </div>
                            <div class="mt:24" v-if="!noButton">
                                <button class="btn btn-primary" @click="confirmHandler()" data-bs-dismiss="modal" type="button" v-text="button || '確認'"></button>
                            </div>
                            <slot name="footer"></slot>
                        </div>
                    </div>
                    <slot name="modalfooter"></slot>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const root = ref();
    const emit = defineEmits(["confirm", "hidden", "shown"]);

    let modal;
    let open = false;

    const confirmHandler = () => {
        emit("confirm");
    };

    const shownHandler = () => {
        open = true;
        emit("shown");
    };

    const hiddenHandler = () => {
        open = false;
        emit("hidden");
    };

    const hide = () => {
        modal.hide();
    };

    const show = () => {
        modal.show();
    };

    const isOpen = () => open;

    defineProps({
        button: { required: false, type: String },
        backdrop: { required: false, type: String },
        additionalClass: { required: false, type: [Array, Object, String] },
        id: String,
        close: { default: true, type: Boolean },
        large: { default: false, type: Boolean },
        noButton: { default: false, type: Boolean }
    });

    defineExpose({ show, hide, isOpen });

    onMounted(() => {
        const el = root.value;
        modal = new bootstrap.Modal(el, { keyboard: false });

        el.addEventListener("shown.bs.modal", shownHandler);
        el.addEventListener("hidden.bs.modal", hiddenHandler);
    });
</script>
